import { AxiosResponse } from "axios";

import http from "../http-common";

import { Trade, TradeDTO } from "../types/Quality/Trade";

/**
 * This will return the list of trades available for users
 *   currenlty we are only looking for active trades howeverthere are other
 *   filter options available that can be implemented in the future
 * @param isActive 
 * @param excludedNames Optional list of trade names to exclude from results
 * @returns AxiosResponse object containing the data retrieved from the API
 */
export const getTrades = async (isActive: boolean = true, excludedNames?: string[]) => {
    let tradeList: Trade[] = [];
    let response = { data: null, status: 0, statusText: '', headers: {}, config: {} } as AxiosResponse;
    try {
        let page = 1;
        /**
         * This loop should, in general, be unnecessary.  It is here for completeness
         */
        do {
            let url = `/listTrades?Page=${page}`;
            if (isActive) {
                url += '&IsActive=true';
            }
            if (excludedNames && excludedNames.length > 0) {
                excludedNames.forEach(name => {
                    url += `&ExcludedNames=${encodeURIComponent(name)}`;
                });
            }
            response = await http.get<TradeDTO>(url);
            const { nextPage, items } = response.data;
            tradeList.push(...items)
            page = nextPage;
        } while (page !== null);

        response.data.items = tradeList;

    } finally {
      // we are skipping the catch here on purpose
      //  we want to allow this pass even though it may be empty
      return response;
    }
}